import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { RadioGroup, Radio } from "@mui/material";
import tw from "tailwind-styled-components";
import { toast } from "react-toastify";
import { InputGroup, Label, FieldWrapper } from "../Styles/InputStyles";

const InitialSettlement = ({
    setActiveStep,
    tenantData,
    setTenantData,
    selectedBed,
    postTenantData,
    selectedBedRoomData,
    selectedBedData,
}) => {
    const toastSelectBed = () =>
        toast.warn("Please Select Bed Id", {
            hideProgressBar: false,
        });
    const [adjustedDues, setAdjustedDues] = useState(0);

    const validationSchema = Yup.object().shape({
        duesType: Yup.string().required("Please select a dues type"),
        adjustAmount: Yup.number()
            .when("duesType", {
                is: (value) => value !== "No dues",
                then: Yup.number()
                    .required("This field is required")
                    .min(0, "Amount cannot be negative"),
                otherwise: Yup.number().notRequired(),
            })
            .nullable(),
    });

    const handleSubmit = (values) => {
        // console.log("Form 3 Values:", values);
        // selectedBed ? postTenantData(values) : toastSelectBed();
    };

    return (
        <div className="bg-white rounded-lg mt-8 w-full">
            <Formik
                initialValues={{
                    duesType: "No dues",
                    adjustAmount: "",
                }}
                validationSchema={validationSchema}
            // onSubmit={()=> {
            //     console.log("submit clicked");
            // }}
            >
                {({ values, setFieldValue, errors, touched }) => (
                    <Form id="initial-settlement-form" onSubmit={(e) => { e.preventDefault(); handleSubmit(values); handleSubmit(tenantData); }}>
                        {/* Dues Section */}
                        <div className="mb-2">
                            <h2 className="text-sm text-gray-500 font-semibold sm:text-xl md:text-lg lg:text-sm mb-2">
                                Dues
                            </h2>

                            <div className="flex flex-col sm:flex-row md:justify-between lg:justify-around bg-gray-50 rounded-lg h-auto sm:h-[70px] px-4 py-4 sm:px-10 md:px-16 lg:px-20 shadow-sm gap-4 sm:gap-6 md:gap-8">
                                <div className="w-full sm:w-1/2 md:w-1/3 flex gap-6 sm:gap-3 md:gap-3 lg:gap-3 items-center flex-wrap">
                                    <Label className="text-gray-600 font-semibold">Security</Label>
                                    <span className="text-[#0078BD] font-bold sm:text-sm md:text-lg lg:text-lg">₹2,000</span>
                                </div>

                                <div className="w-full sm:w-1/2 md:w-1/3 flex gap-3 items-center flex-wrap">
                                    <Label className="text-gray-600 font-semibold">Total Dues</Label>
                                    <span className="text-red-500 font-bold sm:text-sm md:text-lg lg:text-lg">₹2,000</span>
                                </div>
                            </div>



                        </div>

                        {/* Adjust Dues Section */}
                        <div className="mb-2">
                            <h2 className=" text-sm text-gray-500 font-semibold sm:text-xl md:text-lg lg:text-sm ">Adjust Dues</h2>
                            <RadioGroup
                                value={values.duesType}
                                onChange={(e) => {
                                    //   setFieldValue("duesType", e.target.value);
                                    const selectedValue = e.target.value;
                                    setFieldValue("duesType", selectedValue);
                                    if (selectedValue === "No dues") {
                                        setFieldValue("adjustAmount", "");
                                        setAdjustedDues(0);
                                    }
                                }}
                            >
                                <div className="flex justify-between items-center">
                                    {/* NO DUES */}
                                    <div className="w-1/2">
                                        <div className="border border-gray-300 rounded-md p-3 w-[95%]">
                                            <label className="flex items-center gap-2 text-sm text-gray-500 font-normal sm:text-xl md:text-lg lg:text-sm">
                                                <Field type="radio" name="duesType" value="No dues" className="w-auto " />
                                                No dues
                                            </label>
                                        </div>
                                    </div>

                                    {/* PENDING DUES */}
                                    <div className="w-1/2">
                                        <div className="border border-gray-300 rounded-md p-3">
                                            <label className="flex items-center gap-2 text-sm text-gray-500 font-normal sm:text-xl md:text-lg lg:text-sm">
                                                <Field type="radio" name="duesType" value="Pending dues" className="w-auto " />
                                                Pending dues
                                            </label>
                                            {values.duesType === "Pending dues" && (
                                                <Field
                                                    name="adjustAmount"
                                                    type="text"
                                                    placeholder="Enter amount"
                                                    className="w-full border rounded px-2 py-2 mt-2"
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        if (/^\d*$/.test(value)) {
                                                            setFieldValue("adjustAmount", e.target.value);
                                                            setAdjustedDues(e.target.value || 0);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>

                                    </div>

                                </div>
                                {/* TOKEN AMOUNT */}
                                <div className="flex justify-between items-center">
                                    <div className="w-1/2">
                                        <div className="border border-gray-300 rounded-md p-3 w-[95%]">
                                            <label className="flex items-center gap-2 text-sm text-gray-500 font-normal sm:text-xl md:text-lg lg:text-sm">
                                                <Field type="radio" name="duesType" value="Token amount" className="w-auto " />
                                                Token amount
                                            </label>
                                            {values.duesType === "Token amount" && (
                                                <Field
                                                    name="tokenAmount"
                                                    type="text"
                                                    placeholder="Enter amount"
                                                    className="w-full border rounded px-2 py-2 mt-2"
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        if (/^\d*$/.test(value)) {
                                                            setFieldValue("tokenAmount", e.target.value);
                                                            setAdjustedDues(e.target.value || 0);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="w-1/2">
                                        {/* EXCESS PAYMENT */}
                                        <div className="border border-gray-300 rounded-md p-3">
                                            <label className="flex items-center gap-2 text-sm text-gray-500 font-normal sm:text-xl md:text-lg lg:text-sm">
                                                <Field type="radio" name="duesType" value="Excess payment" className="w-auto " />
                                                Excess payment
                                            </label>
                                            {values.duesType === "Excess payment" && (
                                                <Field
                                                    name="excessAmount"
                                                    type="text"
                                                    placeholder="Enter amount"
                                                    className="w-full border rounded px-2 py-2 mt-2"
                                                    onChange={(e) => {
                                                        const { value } = e.target;
                                                        if (/^\d*$/.test(value)) {
                                                            setFieldValue("excessAmount", e.target.value);
                                                            setAdjustedDues(e.target.value || 0);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>

                            </RadioGroup>
                            {errors.adjustAmount && touched.adjustAmount && (
                                <div className="text-red-500 text-sm mt-1">
                                    {errors.adjustAmount}
                                </div>
                            )}
                        </div>
                        <hr className="my-2 border-gray-100" />

                        {/* Dues Summary Section */}

                        <h2 className="text-sm text-gray-500 font-semibold mb-2 sm:text-xl md:text-lg lg:text-sm">
                            Dues Summary
                        </h2>

                        <div className="flex flex-col sm:flex-row bg-gray-50 rounded-lg justify-around h-auto sm:h-[70px] px-4 py-4 sm:px-20 shadow-sm gap-4 sm:gap-0 md:px-5 lg:px-6">
                            <div className="w-full sm:w-1/3 flex gap-11 sm:gap-3 md:gap-3 lg:gap-3 items-center flex-wrap">
                                <Label className="text-gray-600 font-semibold">Total Dues</Label>
                                <span className="text-red-500 font-bold sm:text-sm md:text-lg lg:text-lg">₹2,000</span>
                            </div>

                            <div className="w-full sm:w-1/3 flex gap-5 sm:gap-3 md:gap-3 lg:gap-3 items-center flex-wrap">
                                <Label className="text-gray-600 font-semibold">Adjusted Dues</Label>
                                <span className="text-[#0078BD] font-bold sm:text-sm md:text-lg lg:text-lg">₹{adjustedDues}</span>
                            </div>

                            <div className="w-full sm:w-1/3 flex gap-3 items-center flex-wrap">
                                <Label className="text-gray-600 font-semibold">Remaining Dues</Label>
                                <span className="text-green-600 font-bold sm:text-sm md:text-lg lg:text-lg">
                                    ₹{Math.max(2000 - adjustedDues, 0)}
                                </span>
                            </div>
                        </div>

                        {/* Submit Button */}
                        {/* <button
                            type="submit"
                            className="w-full bg-[#0078BD] text-white py-2 rounded"
                        >
                            Submit
                        </button> */}
                    </Form>
                )}
            </Formik>
        </div>

    );
};

export default InitialSettlement;